// extracted by mini-css-extract-plugin
export default {"root":"GG4x6QWmTv","content":"mSCfvONMYu","editorSectionContainer":"Ykyb4yU7dN","previewSectionContainer":"gv_WcRffUT","tabNavigation":"OXcZu4J_Eo"};